var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GalleryGridBlock"},_vm._l((_vm.images),function(image){return _c('div',{key:image,staticClass:"grid-item",class:_vm.gridItemClass,style:({'backgroundImage': ("url('" + image + "')")})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }